import { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";

interface IPath {
  path: string;
  description: string;
  message: string;
 
}

const RedirectToPath: React.FC<IPath> = ({ path, description, message}) => {
   
  const [ pathTarget, setPathTarget ] = useState<string>();

  useEffect(() => {
    if(!pathTarget) {
   }
   
  },[pathTarget,setPathTarget,description,path, message])

  return (
    <Redirect to={{ pathname: path }} />
  )
   
}

export default RedirectToPath;